import React, { useEffect } from 'react';

const CloseTab = () => {
  useEffect(() => {
    window.close();
  });
  return <>
  <h1>
    Redirecting...
    </h1></>;
};

export default CloseTab;
